import { StateUtils } from '@spartacus/core';
import { CATEGORIES_MENU_ROOT_NODE_ID } from '../categories-menu-state';

export const LOAD_CATEGORIES_ROOT_NODE_ID_MENU = '[Catalog] Categories Menu Root Node Id Load';
export const LOAD_CATEGORIES_ROOT_NODE_ID_MENU_SUCCESS = '[Catalog] Categories Menu Root Node Id Load Success';
export const LOAD_CATEGORIES_ROOT_NODE_ID_MENU_FAIL = '[Catalog] Categories Menu Root Node Id Load Fail';

export class CategoriesMenuRootNodeIdLoad extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_CATEGORIES_ROOT_NODE_ID_MENU;

  constructor() {
    super(CATEGORIES_MENU_ROOT_NODE_ID);
  }
}

export class CategoriesMenuRootNodeIdLoadFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_CATEGORIES_ROOT_NODE_ID_MENU_FAIL;

  constructor(public payload: any) {
    super(CATEGORIES_MENU_ROOT_NODE_ID, payload);
  }
}

export class CategoriesMenuRootNodeIdLoadSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_CATEGORIES_ROOT_NODE_ID_MENU_SUCCESS;

  constructor(public payload: string) {
    super(CATEGORIES_MENU_ROOT_NODE_ID);
  }
}

export type CategoriesMenuRootNodeIdLoadAction =
  | CategoriesMenuRootNodeIdLoad
  | CategoriesMenuRootNodeIdLoadFail
  | CategoriesMenuRootNodeIdLoadSuccess;
